import React, { Component } from 'react';
import UploadFileSizeError from '../../icons/UploadFileSizeError';
import { AnimatedButton } from '@trlogic/ui-pack';
import LanguageUtil from '../../util/LanguageUtil';

class FileSizeErrorComponent extends Component<Props> {
  public render() {
    const { onClose, onOk, maxSizeInMBytes } = this.props;
    return (
      <div className={'flex flex-col gap-[10px] w-[450px] h-[450px] rounded-[24px]'}>
        <div className={'flex items-center justify-center'}>
          <UploadFileSizeError />
        </div>
        <div className={'flex w-full flex-col  gap-[8px] items-center px-5 py-2 justify-center'}>
          <p className={'text-primary font-bold text-[24px] text-center'}>
            {LanguageUtil.get({ id: 'pages.sandbox.error.title', defaultMessage: 'High File Size' })}
          </p>
          <p className='text-[16px] text-[#607080]'>
            {LanguageUtil.get(
              {
                id: 'pages.sandbox.error.errorDescription',
                defaultMessage: `Uploading a file larger than ${maxSizeInMBytes}MB. The flow of the system may be negatively affected. Do you still want to continue?`,
              },
              { 0: `${maxSizeInMBytes}` },
            )}
          </p>
        </div>
        <div className='flex items-center justify-center gap-[20px]'>
          <AnimatedButton
            key='continue'
            customType='outlined'
            text={LanguageUtil.get({ id: 'common.button.continue', defaultMessage: 'Continue' })}
            icon={'play'}
            onClick={onOk}
          />
          <AnimatedButton
            key='cancel'
            customType='fraud'
            text={LanguageUtil.get({ id: 'common.button.cancel', defaultMessage: 'Cancel' })}
            icon={'close'}
            onClick={onClose}
          />
        </div>
      </div>
    );
  }
}

interface Props {
  onClose: () => void;
  onOk: () => void;
  maxSizeInMBytes: number;
}

export default FileSizeErrorComponent;
